import { createGlobalStyle } from "styled-components";

const GlobalFonts = createGlobalStyle`
    @import url('https://fonts.googleapis.com/css2?family=Lato:wght@600;700;800&family=Open+Sans:ital@0;1&family=Playfair+Display:wght@600&family=Rubik:wght@600;700&display=swap');
`;

export default GlobalFonts;